import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const CalendarIcon = ({ width = 20, height = 18, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1' y='2.52536' width='18' height='7.99799' fill={hovered ? 'white' : 'none'} />
      {hovered && <path d='M16.6742 17.1694H19L19 6.14943H1V17.1695L16.6742 17.1694Z' fill={fill} />}
      <path
        d='M9.54237 2.52536H5.88135'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.0341 2.52536H11.373'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.0681 2.52536H19V17.1694H16.6742M4.05085 2.52545H1V17.1695H14.3825M4.66101 6.18646H19'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.44092 2.52542C3.44092 1.68644 3.99007 1 4.66126 1C5.33244 1 5.8816 1.68644 5.8816 2.52542C5.8816 3.36441 5.33244 4.05085 4.66126 4.05085'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.93262 2.5254C8.93262 1.68642 9.48177 0.999977 10.153 0.999977C10.8241 0.999977 11.3733 1.68642 11.3733 2.5254C11.3733 3.36438 10.8241 4.05083 10.153 4.05083'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.4238 2.5254C14.4238 1.68642 14.973 0.999977 15.6442 0.999977C16.3154 0.999977 16.8645 1.68642 16.8645 2.5254C16.8645 3.36438 16.3154 4.05083 15.6442 4.05083'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.75 8.33484H12.25L10.6147 10.2038C9.97667 10.9329 9.625 11.8689 9.625 12.8378V15.0848'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
